import service from '../../http/axios';

// 获取病变列表
export const getListLessonsType = service({
  url: '/yinghe-api/userVsAiSetting/listLessonsType',
});

// 获取病变属性列表
export const getAttributes = service({
  url: '/yinghe-api/tagResult/attributes',
});

// 获取所有标注用户
export const getMarkUsers = service({
  url: '/yinghe-api/tagResult/listAllMembers',
});

// 获取标注属性列表
export const getMarkPropertyList = service({
  url: '/yinghe-api/tagResult/listTags',
});

// 获取标注绘图列表
export const getMarkList = service({
  url: '/yinghe-api/tagResult/listTagsArea',
});
// 添加标注
export const createMark = service({
  method: 'POST',
  url: '/yinghe-api/tagResult/add',
});
// 更新标注
export const updateMark = service({
  method: 'POST',
  url: '/yinghe-api/tagResult/update',
});
// 删除标注
export const removeMark = service({
  url: '/yinghe-api/tagResult/delete',
});

// 一键删除标注 lhwen add
export const removeMarkByBatch = service({
  method: 'DELETE',
  url: '/yinghe-api/tagResult/deleteTagsByBatch',
});

// 标注完成
export const updateMarkEnd = service({
  method: 'POST',
  url: '/yinghe-api/tagResult/labelComplete',
});

// 审核
export const checkMark = service({
  method: 'POST',
  url: '/yinghe-api/imageDataScienceSchedule/checkTag',
});

// 获取标注操作权限
export const getMarkActionPermission = service({
  url: '/yinghe-api/tagResult/getActions',
});
